/* @flow */
import UserAgent from 'lib/UserAgent';

const uaStr = (typeof window === 'undefined') ?
  '' :
  window.navigator.userAgent;

export default new UserAgent(uaStr);



// WEBPACK FOOTER //
// ./src/lib/currentUserAgent.js